import ShowIfPrint from './ShowIfPrint';
export default ShowIfPrint;



// WEBPACK FOOTER //
// ./src/components/ShowIfPrint/index.js